import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white" data-id="element-98" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-99" data-mp="1cf03nb26x4mz">
        <div className="text-center mb-16" data-id="element-100" data-mp="1cgb8le7dgifo">
          <p className="text-azure font-bold tracking-widest uppercase text-sm mb-3" data-id="element-101" data-mp="2a1ytb1ugtcbd">
            Everything You Need to Know
          </p>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy" data-id="element-102" data-mp="254grdvev7xcv">
            ❓ Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-103" data-mp="1v4zpzq6nc5mp">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-white border border-mist-dark rounded-xl overflow-hidden shadow-sm" data-id="element-104" data-mp="1v72cw1ci5in7" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-105" data-mp="jorjxes0ac6a">
                <span className="font-bold text-lg text-navy pr-8" data-id="element-106" data-mp="1arwv93lpo45v">{faq.q}</span>
                <ChevronDown className={`text-gold-dark transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-107" data-mp="1fmst4kdmplqw" />
              </button>
              <AnimatePresence initial={false} data-id="element-108" data-mp="16ps6ai67jvpk">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-109" data-mp="rwyfw1pedv64">
                    <div className="px-6 pb-5 text-slate border-t border-mist-dark pt-4" data-id="element-110" data-mp="2pmwv7l9j656d">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}